import { Grid, Input } from '@enterprise-ui/canvas-ui-react';
import React__default from 'react';
import useCanvasId from '../../../../utils/useCanvasId.js';
import { SET_PAGE_SIZE } from './utils/constants.js';
import { usePagination } from './utils/hooks.js';

var PageSize = function PageSize(_ref) {
  var dataTestId = _ref.dataTestId;
  var _usePagination = usePagination(),
    dispatch = _usePagination.dispatch,
    _usePagination$state = _usePagination.state,
    currentPage = _usePagination$state.currentPage,
    hidePageSize = _usePagination$state.hidePageSize,
    isClient = _usePagination$state.isClient,
    onPageSizeChange = _usePagination$state.onPageSizeChange,
    pageSize = _usePagination$state.pageSize,
    pageSizeOptions = _usePagination$state.pageSizeOptions,
    totalPages = _usePagination$state.totalPages;
  var onPaginationPageSizeChange = function onPaginationPageSizeChange(event) {
    var newPageSize = pageSizeOptions[Number(event.target.value)];
    if (isClient) {
      dispatch({
        payload: pageSizeOptions[Number(event.target.value)],
        type: SET_PAGE_SIZE
      });
    }
    if (typeof onPageSizeChange === 'function') {
      onPageSizeChange({
        currentPage: currentPage,
        event: event,
        newPageSize: newPageSize,
        pageSize: pageSize,
        totalPages: totalPages
      });
    }
  };
  var pageSelectId = "".concat(useCanvasId(), "-pageSizeSelect");
  return /*#__PURE__*/React__default.createElement(Grid.Item, {
    className: "C-Pagination__childComponent",
    xs: 4
  }, hidePageSize !== true && /*#__PURE__*/React__default.createElement(Grid.Container, {
    align: "center",
    className: "C-Pagination__pageSize hc-mb-normal"
  }, /*#__PURE__*/React__default.createElement(Grid.Item, null, /*#__PURE__*/React__default.createElement(Input.Label, {
    className: "hc-mb-none hc-clr-grey01",
    htmlFor: "pageSizeSelect"
  }, "Items per page")), /*#__PURE__*/React__default.createElement(Grid.Item, null, /*#__PURE__*/React__default.createElement(Input.Select, {
    id: pageSelectId,
    "data-testid": dataTestId ? "".concat(dataTestId, "_pageSizeSelect") : null,
    size: "dense",
    value: pageSize,
    onChange: function onChange(event) {
      onPaginationPageSizeChange(event);
    },
    options: pageSizeOptions.map(function (option) {
      return {
        label: option,
        value: option
      };
    })
  }))));
};

export { PageSize as default };
